<ul class="nav nav-tabs" id="myTab" role="tablist">
	<li class="nav-item">
		<a
			class="nav-link active"
			id="tasks-active-tab"
			data-bs-toggle="tab"
			href="#tasks-active"
			role="tab"
			aria-controls="tasks"
			aria-selected="false"
		>
			Zadania - Aktywne
		</a>
	</li>
	<li class="nav-item">
		<a
			class="nav-link"
			id="tasks-add-tab"
			data-bs-toggle="tab"
			href="#tasks-add"
			role="tab"
			aria-controls="tasks-add"
			aria-selected="false"
		>
			Dodaj zadanie
		</a>
	</li>
	<li class="nav-item">
		<a
			class="nav-link"
			id="tasks-completed-tab"
			data-bs-toggle="tab"
			href="#tasks-completed"
			role="tab"
			aria-controls="tasks-completed"
			aria-selected="false"
		>
			Zadania - Zakończone
		</a>
	</li>
</ul>
<div class="tab-content" id="myTabContent">
	<div class="tab-pane fade active show" id="tasks-active" role="tabpanel" aria-labelledby="tasks-active-tab">
		<div class="card">
			<div class="card-body">
				<div class="card-text">
					<div class="row" *ngFor="let item of tasks.active">
						<div class="col-sm-2">
							<button type="button" class="btn btn-link btn-sm me-2" (click)="askAction('2', item.id)">
								Zakończ
							</button>
							<button
								type="button"
								class="btn btn-outline-light btn-sm"
								[ngStyle]="{
									color: item.color,
									'border-color': item.color,
								}"
								disabled
							>
								{{ item.typeName }}
							</button>
						</div>
						<div class="col-sm-10">
							<p>
								<span [innerHTML]="item.content"></span><br />
								<small
									>Osoba odpowiedzialna:<b> {{ item.ownersName }}</b> termin do
									<b>{{ item.deadline }}</b></small
								><br />
								<small
									>Autor:<b> {{ item.authorName }}</b> utworzone<b>{{ item.created }}</b></small
								>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="tab-pane fade" id="tasks-add" role="tabpanel" aria-labelledby="tasks-add-tab">
		<div class="card">
			<div class="card-body">
				<div class="card-text">
					<app-php-task-add
						[types]="types"
						[users]="users"
						[objType]="objType"
						[objId]="objId"
					></app-php-task-add>
				</div>
			</div>
		</div>
	</div>
	<div class="tab-pane fade" id="tasks-completed" role="tabpanel" aria-labelledby="tasks-completed-tab">
		<div class="card">
			<div class="card-body">
				<div class="row" *ngFor="let item of tasks.completed">
					<div class="col-sm-4">
						<button type="button" class="btn btn-link btn-sm me-2" (click)="askAction('1', item.id)">
							Przywróć
						</button>
						<button
							type="button"
							class="btn btn-outline-light btn-sm"
							[ngStyle]="{
								color: item.color,
								'border-color': item.color,
							}"
							disabled
						>
							{{ item.typeName }}
						</button>
					</div>
					<div class="col-sm-8">
						<p>
							<span [innerHTML]="item.content"></span><br />
							<small
								>Osoba odpowiedzialna:<b> {{ item.ownersName }}</b> termin do
								<b>{{ item.deadline }}</b></small
							><br />
							<small
								>Autor:<b> {{ item.authorName }}</b> utworzone<b>{{ item.created }}</b></small
							>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
